
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1548.01 670.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"topRecipt",attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M74.43,238l-26.7,29L21,238,1,267V1M254.67,48.81V267l-20-29-26.7,29-26.7-29-26.7,29L127.9,238.77,101.13,267M1,267"}}),_c('line',{attrs:{"x1":"37","y1":"48.81","x2":"217","y2":"48.81"}}),_c('line',{attrs:{"x1":"37","y1":"80.81","x2":"217","y2":"80.81"}}),_c('line',{attrs:{"x1":"37","y1":"118.02","x2":"217","y2":"118.02"}}),_c('line',{attrs:{"x1":"37","y1":"150.02","x2":"217","y2":"150.02"}}),_c('line',{attrs:{"x1":"37","y1":"184.23","x2":"127.84","y2":"184.23"}})]),_c('g',{staticClass:"btmRecipt",attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M1500.28,403.18l26.71,29,20-29v266m-253.67-47.82V403.18l20,29,26.7-29,26.7,29,26.71-29,26.63,28.25,26.77-28.25,26.7,29m73.43-29"}}),_c('line',{attrs:{"x1":"1511.01","y1":"621.38","x2":"1331.01","y2":"621.38"}}),_c('line',{attrs:{"x1":"1511.01","y1":"589.38","x2":"1331.01","y2":"589.38"}}),_c('line',{attrs:{"x1":"1511.01","y1":"552.18","x2":"1331.01","y2":"552.18"}}),_c('line',{attrs:{"x1":"1511.01","y1":"520.18","x2":"1331.01","y2":"520.18"}}),_c('line',{attrs:{"x1":"1424.04","y1":"485.97","x2":"1333.2","y2":"485.97"}})])])
          )
        }
      }
    